export default __webpack_public_path__ + "static/media/seller-img2.c646360e.png";